import { createFileRoute } from "@tanstack/react-router";
import { staticSitemapRoute } from "@/lib/core/sitemaps";

export const Route = createFileRoute("/sitemaps/static.xml")({
    ...staticSitemapRoute,
});
